/****************************************************
 * Module Name:  MappedConsigneeDetail.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState, useEffect } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import renderCellExpand from "../common/dataGridCellExpand";
import { Box, Tooltip } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import Constants from "../../utility/constants";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Utility from "../../utility/utility";
import WolzaIndiaExportProxy from "../../utility/proxy/nivodautility/wolzaIndiaExportProxy";
import dayjs from "dayjs";

const MappedConsigneeDetail = ({
    stoneid,
    fromDate,
    toDate,
    stonetype,
}) => {

    useEffect(() => {
        handleSearch(stoneid);
    }, ([]));

    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [detailLoader, setDetailLoader] = useState(false);
    const [data, setData] = useState([]);
    const [filterValues, setFilterValues] = useState({});
    // const [access, setAccess] = useState(false);

    const handleSearch = (stoneid) => {
        setDetailLoader(true);

        let reqData = {
            from: (fromDate !== null && fromDate !== "") ?
                dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000Z" : null,
            to: (toDate !== null && toDate !== "") ?
                dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999Z" : null,
        }

        WolzaIndiaExportProxy.GetMarketStonePotentialForStoneForMappedUser(stoneid, reqData, stonetype,
            (responseData) => {
                if (responseData) {
                    const uniqueFilterValues = {
                        usercompanyname: Utility.getDistinctOptions(responseData, "usercompanyname"),
                        username: Utility.getDistinctOptions(responseData, "username"),
                        userfirstname: Utility.getDistinctOptions(responseData, "userfirstname"),
                        userlastname: Utility.getDistinctOptions(responseData, "userlastname"),
                        useremail: Utility.getDistinctOptions(responseData, "useremail"),
                        employeeusername: Utility.getDistinctOptions(responseData, "employeeusername"),
                        employeefirstname: Utility.getDistinctOptions(responseData, "employeefirstname"),
                        employeecompanyname: Utility.getDistinctOptions(responseData, "employeecompanyname"),
                        employeeemail: Utility.getDistinctOptions(responseData, "employeeemail"),
                    };
                    setFilterValues(uniqueFilterValues);
                    setData(responseData)
                    setDetailLoader(false);
                } else {
                    setErrorSnackbar(true);
                    setDetailLoader(false);
                }
            });
    }

    const initialColumns = () => [
        {
            field: "userid",
            headerName: "CUSTOMERID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
            renderCell: renderCellExpand,
        },
        {
            field: "username",
            headerName: "USERNAME",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.username : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "usercompanyname",
            headerName: "COMPANY NAME",
            headerAlign: "center",
            align: "center",
            width: 150, type: "singleSelect",
            valueOptions: filterValues ? filterValues.usercompanyname : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "userfirstname",
            headerName: "FIRST NAME",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.userfirstname : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "userlastname",
            headerName: "LAST NAME",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.userlastname : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "useremail",
            headerName: "EMAIL",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.useremail : [],
            filterOperators: Utility.combinedFilters(),
            width: 160,
            renderCell: renderCellExpand,
        },
        {
            field: "userphone",
            headerName: "PHONE",
            headerAlign: "center",
            align: "center",
            width: 120,
            renderCell: renderCellExpand,
        },
        {
            field: "employeeid",
            headerName: "EMPLOYEEID",
            headerAlign: "center",
            align: "center",
            width: 120,
            renderCell: renderCellExpand,
        },
        {
            field: "employeeusername",
            headerName: "EMP USERNAME",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.employeeusername : [],
            filterOperators: Utility.combinedFilters(),
            width: 120,
            renderCell: renderCellExpand,
        },
        {
            field: "employeefirstname",
            headerName: "EMP FIRSTNAME",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.employeefirstname : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "employeecompanyname",
            headerName: "EMP COMPANYNAME",
            headerAlign: "center",
            align: "center",
            width: 150,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.employeecompanyname : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "employeeemail",
            headerName: "EMP EMAIL",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.employeeemail : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "employeephone",
            headerName: "EMP PHONE",
            headerAlign: "center",
            align: "center",
            width: 120,
            renderCell: renderCellExpand,
        },
        {
            field: "sellcount",
            headerName: "SELL COUNT",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
            renderCell: renderCellExpand,
        },
        {
            field: "quantity",
            headerName: "QTY",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
            renderCell: renderCellExpand,
        },
        {
            field: "sumofestimatedfob",
            headerName: "SUM OF FOB",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
            renderCell: renderCellExpand,
        },
        {
            field: "avgppc",
            headerName: "AVG PPC",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 120,
            renderCell: renderCellExpand,
        },
    ]

    const columns = initialColumns();

    return (
        <div>
            <CommonSnackbar
                show={errorSnackbar}
                message={Constants.APiFailErrorMessage}
                variant={"error"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Failed"}
                handleClose={() => setErrorSnackbar(false)}
            />
            {
                // access ? <NoPermission /> : (
                <Box px={1} >
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .lavenderCell": {
                                color: "#080808",
                                backgroundColor: "#D8BFD8",
                            },
                            "& .greenCell": {
                                color: "#080808",
                                backgroundColor: "#B6D7A8"
                            },
                            "& .redCell": {
                                color: "#080808",
                                backgroundColor: "#f5d7d7",
                            },
                            "& .yellowCell": {
                                color: "#080808",
                                backgroundColor: "#F1E68C",
                            },
                            height: "65vh",
                        }}
                    >
                        <DataGridPro
                            disableRowSelectionOnClick={false}
                            density="compact"
                            loading={detailLoader}
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    color: '#fff',
                                    backgroundColor: 'grey',
                                },
                                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                    py: "4px",
                                },
                                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                    py: "12px",
                                },
                                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                    py: "18px",
                                },

                                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                            }}
                            slots={{ toolbar: GridToolbar }}
                            rows={data}
                            columns={columns}
                            getRowId={(row) => row.userid}
                            rowSpacingType="border"
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        // Hide columns status and traderName, the other columns will remain visible
                                        userid: false,
                                        employeeid: false,
                                    },
                                },
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />
                        <Box
                            style={{
                                position: "absolute",
                                top: 5,
                                right: "270px",
                                display: "flex",
                                flexWrap: "nowrap",
                                height: "33px"
                            }}>
                            {detailLoader ? (
                                <CircularProgress size="1rem" />
                            ) : (
                                <Tooltip title="Reload List">
                                    <RefreshOutlinedIcon
                                        onClick={() => handleSearch(stoneid)}
                                        color="primary"
                                        fontSize="medium"
                                        sx={{ cursor: "pointer" }}
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </Box>
                </Box>
                // )
            }
        </div>
    )
};

export default MappedConsigneeDetail;